module.exports = __webpack_public_path__ + "static/img/logo.b8139b46.png";